export default {"src":"/_next/static/media/hybrid-cloud.54b05c7f.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};